export default {
  en: {
    answerPlaceholder: "Type your answer and/or upload media. Press Enter to send, Shift+Enter for a new line",
    send: "Send",
    thinking: "Thinking…",
    processingMedia: "Processing your media…",
    interviewComplete: "Thank you — this interview is complete.",
    groupCompleteAwaitingEmail: "Thank you for completing this part. We'll email you when the next part is ready.",
    groupCompleteAwaitingSaveLink: "Thank you for completing this part. Save the link below so you can return when the next part is ready.",
    saveLinkReminderTitle: "Save this link",
    saveLinkReminderBody: "This interview continues over multiple days. Either use the link you were sent via email, bookmark this page or copy the link below - you'll need it to return for the next part.",
    saveLinkEmailDivider: "Or get notified by email",
    saveLinkEmailHint: "Optional. We'll email you when the next part is ready instead of relying on this link alone.",
    copyLink: "Copy link",
    linkCopied: "Link copied",
    contactEmailLabel: "Email address",
    contactEmailPlaceholder: "you@example.com",
    contactEmailRequired: "Please enter a valid email address so we can notify you when the next part is ready.",
    saveContactEmail: "Save email",
    contactEmailSaved: "Email saved. We'll notify you when the next part is ready.",
    submitError: "Something went wrong sending your answer. Please try again.",
    replyError: "Your answer was sent, but Maya could not reply. Please try again in a moment.",
    removeAttachment: "Remove attachment",
    attachmentPreviewRegion: "Attachment preview",
    reviewAttachmentBeforeSend: "Check this is the right file before you send.",
    reviewAttachmentsBeforeSend: "Check these are the right files before you send.",
    reviewVideoBeforeSend: "Check this is the right video before you send.",
    reviewAudioBeforeSend: "Check this is the right audio before you send.",
    uploadingMedia: "Uploading…",
    cancelUpload: "Cancel upload",
    uploadCancelled: "Upload cancelled.",
    attachMedia: "Attach media",
    mediaUploadHint: "Accepted upload file types: {types}. Max {maxSize}.",
    mediaUploadInvalidType: "That file type is not supported. Please choose one of the accepted file types.",
    mediaUploadTooLarge: "That file is too large. The maximum upload size is {maxSize}.",
    mediaUploadTooMany: "You can attach up to {max} files per message.",
    recordVideo: "Record video",
    recorderConsentBody: "By continuing, you consent to your camera and microphone being used to record your video response. Your recording will be stored securely with your other responses and reviewed by the research team.",
    recorderConsentFallback: "Prefer not to record? You can type, record audio or attach a file instead.",
    recorderAccept: "Allow camera and microphone",
    recorderDecline: "Not now",
    recorderClose: "Close recorder",
    recorderStart: "Start recording",
    recorderStop: "Stop recording",
    recorderRetake: "Record again",
    recorderUse: "Use this video",
    recorderRecording: "Recording",
    recorderPreparingCamera: "Preparing your camera…",
    recorderReady: "Press start when you are ready to record.",
    recorderReview: "Review your recording, then use it or record again.",
    recorderPermissionDenied: "Camera or microphone access was blocked. Allow access in your browser settings, or attach a file instead.",
    recorderUnsupported: "Video recording is not supported in this browser. Try attaching a video file instead.",
    recorderTooShort: "That recording was too short. Record for at least one second, or try again.",
    insertEmoji: "Insert emoji",
    dictateAnswer: "Dictate answer",
    stopDictating: "Stop dictating",
    dictateMicError: "Microphone access was blocked or speech recognition failed. Check browser permissions and try again.",
    dictateMicDenied: "Microphone access appears to still be blocked for this site. If you have already allowed the microphone in your browser site settings, please just refresh your page and then try again.",
    dictateNoSpeech: "No speech was detected. Click the mic and try again.",
    dictateConnecting: "Initialising microphone… wait a moment before you speak.",
    dictateListening: "Listening… speak now. Click the mic to stop or Send when you are done.",
    dictateStartTimeout: "Dictation did not start in time. Wait a moment and try again, or type your answer instead.",
    startingInterview: "Starting interview…",
    selectLanguage: "Language",
    startInterview: "Start interview",
    playQuestion: "Play question",
    stopPlayback: "Stop playback",
    playbackError: "Could not play this message. Please read the text instead.",
  },
  in: {
    answerPlaceholder: "Ketik jawaban Anda dan/atau unggah media. Tekan Enter untuk mengirim, Shift+Enter untuk baris baru",
    send: "Kirim",
    thinking: "Sedang berpikir…",
    processingMedia: "Memproses media Anda…",
    interviewComplete: "Terima kasih — wawancara ini telah selesai.",
    groupCompleteAwaitingEmail: "Terima kasih telah menyelesaikan bagian ini. Kami akan mengirim email kepada Anda saat bagian berikutnya siap.",
    groupCompleteAwaitingSaveLink: "Terima kasih telah menyelesaikan bagian ini. Simpan tautan di bawah agar Anda dapat kembali saat bagian berikutnya siap.",
    saveLinkReminderTitle: "Simpan tautan ini",
    saveLinkReminderBody: "Wawancara ini berlanjut selama beberapa hari. Gunakan tautan yang dikirim melalui email, tandai halaman ini, atau salin tautan di bawah — Anda memerlukannya untuk kembali pada bagian berikutnya.",
    saveLinkEmailDivider: "Atau dapatkan pemberitahuan melalui email",
    saveLinkEmailHint: "Opsional. Kami akan mengirim email saat bagian berikutnya siap, tanpa hanya mengandalkan tautan ini.",
    copyLink: "Salin tautan",
    linkCopied: "Tautan disalin",
    contactEmailLabel: "Alamat email",
    contactEmailPlaceholder: "anda@contoh.com",
    contactEmailRequired: "Masukkan alamat email yang valid agar kami dapat memberi tahu Anda saat bagian berikutnya siap.",
    saveContactEmail: "Simpan email",
    contactEmailSaved: "Email disimpan. Kami akan memberi tahu Anda saat bagian berikutnya siap.",
    submitError: "Terjadi kesalahan saat mengirim jawaban Anda. Silakan coba lagi.",
    replyError: "Jawaban Anda terkirim, tetapi Maya tidak dapat membalas. Silakan coba lagi sebentar lagi.",
    removeAttachment: "Hapus lampiran",
    attachmentPreviewRegion: "Pratinjau lampiran",
    reviewAttachmentBeforeSend: "Periksa bahwa ini adalah file yang benar sebelum mengirim.",
    reviewAttachmentsBeforeSend: "Periksa bahwa ini adalah file yang benar sebelum mengirim.",
    reviewVideoBeforeSend: "Periksa bahwa ini adalah video yang benar sebelum mengirim.",
    reviewAudioBeforeSend: "Periksa bahwa ini adalah audio yang benar sebelum mengirim.",
    uploadingMedia: "Mengunggah…",
    cancelUpload: "Batalkan unggahan",
    uploadCancelled: "Unggahan dibatalkan.",
    attachMedia: "Lampirkan media",
    mediaUploadHint: "Jenis file yang diterima: {types}. Maks. {maxSize}.",
    mediaUploadInvalidType: "Jenis file itu tidak didukung. Pilih salah satu jenis file yang diterima.",
    mediaUploadTooLarge: "File terlalu besar. Ukuran unggahan maksimum adalah {maxSize}.",
    mediaUploadTooMany: "Anda dapat melampirkan hingga {max} file per pesan.",
    recordVideo: "Rekam video",
    recorderConsentBody: "Dengan melanjutkan, Anda menyetujui penggunaan kamera dan mikrofon untuk merekam respons video Anda. Rekaman Anda akan disimpan dengan aman bersama respons lainnya dan ditinjau oleh tim riset.",
    recorderConsentFallback: "Tidak ingin merekam? Anda dapat mengetik, merekam audio, atau melampirkan file sebagai gantinya.",
    recorderAccept: "Izinkan kamera dan mikrofon",
    recorderDecline: "Tidak sekarang",
    recorderClose: "Tutup perekam",
    recorderStart: "Mulai merekam",
    recorderStop: "Berhenti merekam",
    recorderRetake: "Rekam lagi",
    recorderUse: "Gunakan video ini",
    recorderRecording: "Merekam",
    recorderPreparingCamera: "Menyiapkan kamera Anda…",
    recorderReady: "Tekan mulai saat Anda siap merekam.",
    recorderReview: "Tinjau rekaman Anda, lalu gunakan atau rekam lagi.",
    recorderPermissionDenied: "Akses kamera atau mikrofon diblokir. Izinkan akses di pengaturan browser, atau lampirkan file sebagai gantinya.",
    recorderUnsupported: "Perekaman video tidak didukung di browser ini. Coba lampirkan file video sebagai gantinya.",
    recorderTooShort: "Rekaman terlalu pendek. Rekam setidaknya satu detik, atau coba lagi.",
    insertEmoji: "Sisipkan emoji",
    dictateAnswer: "Ucapkan jawaban",
    stopDictating: "Berhenti mendikte",
    dictateMicError: "Akses mikrofon diblokir atau pengenalan suara gagal. Periksa izin browser dan coba lagi.",
    dictateMicDenied: "Akses mikrofon tampaknya masih diblokir untuk situs ini. Jika Anda sudah mengizinkan mikrofon di pengaturan situs browser, silakan segarkan halaman Anda lalu coba lagi.",
    dictateNoSpeech: "Tidak ada suara terdeteksi. Klik mikrofon dan coba lagi.",
    dictateConnecting: "Menginisialisasi mikrofon… tunggu sebentar sebelum berbicara.",
    dictateListening: "Mendengarkan… bicara sekarang. Klik mikrofon untuk berhenti atau Kirim jika sudah selesai.",
    dictateStartTimeout: "Dikte tidak dimulai tepat waktu. Tunggu sebentar dan coba lagi, atau ketik jawaban Anda.",
    startingInterview: "Memulai wawancara…",
    selectLanguage: "Bahasa",
    startInterview: "Mulai wawancara",
    playQuestion: "Putar pertanyaan",
    stopPlayback: "Hentikan pemutaran",
    playbackError: "Tidak dapat memutar pesan ini. Silakan baca teksnya.",
  },
  zh: {
    answerPlaceholder: "输入您的回答和/或上传媒体。按 Enter 发送，Shift+Enter 换行",
    send: "发送",
    thinking: "思考中…",
    processingMedia: "正在处理您的媒体…",
    interviewComplete: "谢谢 — 本次访谈已完成。",
    groupCompleteAwaitingEmail: "感谢您完成这一部分。下一部分准备好后，我们会通过电子邮件通知您。",
    groupCompleteAwaitingSaveLink: "感谢您完成这一部分。请保存下面的链接，以便在下一部分准备好时返回。",
    saveLinkReminderTitle: "保存此链接",
    saveLinkReminderBody: "本次访谈将持续多天。请使用通过电子邮件发送的链接、收藏此页面或复制下面的链接 — 您需要它来返回下一部分。",
    saveLinkEmailDivider: "或通过电子邮件获取通知",
    saveLinkEmailHint: "可选。下一部分准备好时，我们会通过电子邮件通知您，而不仅依赖此链接。",
    copyLink: "复制链接",
    linkCopied: "链接已复制",
    contactEmailLabel: "电子邮件地址",
    contactEmailPlaceholder: "you@example.com",
    contactEmailRequired: "请输入有效的电子邮件地址，以便我们在下一部分准备好时通知您。",
    saveContactEmail: "保存电子邮件",
    contactEmailSaved: "电子邮件已保存。下一部分准备好时，我们会通知您。",
    submitError: "发送回答时出错，请重试。",
    replyError: "您的回答已发送，但 Maya 无法回复。请稍后再试。",
    removeAttachment: "移除附件",
    attachmentPreviewRegion: "附件预览",
    reviewAttachmentBeforeSend: "发送前请确认这是正确的文件。",
    reviewAttachmentsBeforeSend: "发送前请确认这些是正确的文件。",
    reviewVideoBeforeSend: "发送前请确认这是正确的视频。",
    reviewAudioBeforeSend: "发送前请确认这是正确的音频。",
    uploadingMedia: "正在上传…",
    cancelUpload: "取消上传",
    uploadCancelled: "上传已取消。",
    attachMedia: "附加媒体",
    mediaUploadHint: "可接受的上传文件类型：{types}。最大 {maxSize}。",
    mediaUploadInvalidType: "不支持该文件类型。请选择可接受的文件类型之一。",
    mediaUploadTooLarge: "文件过大。最大上传大小为 {maxSize}。",
    mediaUploadTooMany: "每条消息最多可附加 {max} 个文件。",
    recordVideo: "录制视频",
    recorderConsentBody: "继续即表示您同意使用您的摄像头和麦克风录制视频回答。您的录制内容将与您的其他回答一起安全存储，并由研究团队审阅。",
    recorderConsentFallback: "不想录制？您可以改为输入文字、录制音频或附加文件。",
    recorderAccept: "允许使用摄像头和麦克风",
    recorderDecline: "暂不",
    recorderClose: "关闭录制器",
    recorderStart: "开始录制",
    recorderStop: "停止录制",
    recorderRetake: "重新录制",
    recorderUse: "使用此视频",
    recorderRecording: "录制中",
    recorderPreparingCamera: "正在准备摄像头…",
    recorderReady: "准备好后请按开始录制。",
    recorderReview: "请查看录制内容，然后使用或重新录制。",
    recorderPermissionDenied: "摄像头或麦克风访问被阻止。请在浏览器设置中允许访问，或改为附加文件。",
    recorderUnsupported: "此浏览器不支持视频录制。请尝试附加视频文件。",
    recorderTooShort: "录制时间太短。请至少录制一秒，或重试。",
    insertEmoji: "插入表情",
    dictateAnswer: "语音输入回答",
    stopDictating: "停止语音输入",
    dictateMicError: "麦克风访问被阻止或语音识别失败。请检查浏览器权限后重试。",
    dictateMicDenied: "此网站的麦克风访问似乎仍被阻止。如果您已在浏览器网站设置中允许麦克风，请刷新页面后重试。",
    dictateNoSpeech: "未检测到语音。请点击麦克风后重试。",
    dictateConnecting: "正在初始化麦克风…请稍候再开始说话。",
    dictateListening: "正在聆听…请现在说话。点击麦克风停止，完成后点击发送。",
    dictateStartTimeout: "语音输入未能及时启动。请稍候再试，或直接输入您的回答。",
    startingInterview: "正在开始访谈…",
    selectLanguage: "语言",
    startInterview: "开始访谈",
    playQuestion: "播放问题",
    stopPlayback: "停止播放",
    playbackError: "无法播放此消息。请改为阅读文字。",
  },
  nl: {
    answerPlaceholder: "Typ uw antwoord en/of upload media. Druk op Enter om te verzenden, Shift+Enter voor een nieuwe regel",
    send: "Verzenden",
    thinking: "Bezig met nadenken…",
    processingMedia: "Uw media wordt verwerkt…",
    interviewComplete: "Bedankt — dit interview is afgerond.",
    groupCompleteAwaitingEmail: "Bedankt voor het afronden van dit onderdeel. We sturen u een e-mail wanneer het volgende onderdeel klaar is.",
    groupCompleteAwaitingSaveLink: "Bedankt voor het afronden van dit onderdeel. Bewaar de onderstaande link zodat u kunt terugkeren wanneer het volgende onderdeel klaar is.",
    saveLinkReminderTitle: "Bewaar deze link",
    saveLinkReminderBody: "Dit interview loopt over meerdere dagen. Gebruik de link die u per e-mail hebt ontvangen, maak een bladwijzer van deze pagina of kopieer de onderstaande link — u heeft deze nodig om terug te keren voor het volgende onderdeel.",
    saveLinkEmailDivider: "Of ontvang een melding per e-mail",
    saveLinkEmailHint: "Optioneel. We sturen u een e-mail wanneer het volgende onderdeel klaar is, in plaats van alleen op deze link te vertrouwen.",
    copyLink: "Link kopiëren",
    linkCopied: "Link gekopieerd",
    contactEmailLabel: "E-mailadres",
    contactEmailPlaceholder: "u@example.com",
    contactEmailRequired: "Voer een geldig e-mailadres in zodat we u kunnen informeren wanneer het volgende onderdeel klaar is.",
    saveContactEmail: "E-mail opslaan",
    contactEmailSaved: "E-mail opgeslagen. We informeren u wanneer het volgende onderdeel klaar is.",
    submitError: "Er ging iets mis bij het verzenden van uw antwoord. Probeer het opnieuw.",
    replyError: "Uw antwoord is verzonden, maar Maya kon niet antwoorden. Probeer het zo meteen opnieuw.",
    removeAttachment: "Bijlage verwijderen",
    attachmentPreviewRegion: "Voorbeeld van bijlage",
    reviewAttachmentBeforeSend: "Controleer of dit het juiste bestand is voordat u verzendt.",
    reviewAttachmentsBeforeSend: "Controleer of dit de juiste bestanden zijn voordat u verzendt.",
    reviewVideoBeforeSend: "Controleer of dit de juiste video is voordat u verzendt.",
    reviewAudioBeforeSend: "Controleer of dit de juiste audio is voordat u verzendt.",
    uploadingMedia: "Uploaden…",
    cancelUpload: "Upload annuleren",
    uploadCancelled: "Upload geannuleerd.",
    attachMedia: "Media bijvoegen",
    mediaUploadHint: "Geaccepteerde bestandstypen: {types}. Max. {maxSize}.",
    mediaUploadInvalidType: "Dit bestandstype wordt niet ondersteund. Kies een van de geaccepteerde bestandstypen.",
    mediaUploadTooLarge: "Dit bestand is te groot. De maximale uploadgrootte is {maxSize}.",
    mediaUploadTooMany: "U kunt maximaal {max} bestanden per bericht bijvoegen.",
    recordVideo: "Video opnemen",
    recorderConsentBody: "Door verder te gaan, stemt u ermee in dat uw camera en microfoon worden gebruikt om uw video-antwoord op te nemen. Uw opname wordt veilig opgeslagen bij uw andere antwoorden en bekeken door het onderzoeksteam.",
    recorderConsentFallback: "Liever niet opnemen? U kunt in plaats daarvan typen, audio opnemen of een bestand bijvoegen.",
    recorderAccept: "Camera en microfoon toestaan",
    recorderDecline: "Niet nu",
    recorderClose: "Recorder sluiten",
    recorderStart: "Opname starten",
    recorderStop: "Opname stoppen",
    recorderRetake: "Opnieuw opnemen",
    recorderUse: "Deze video gebruiken",
    recorderRecording: "Opnemen",
    recorderPreparingCamera: "Uw camera wordt voorbereid…",
    recorderReady: "Druk op start wanneer u klaar bent om op te nemen.",
    recorderReview: "Bekijk uw opname en gebruik deze of neem opnieuw op.",
    recorderPermissionDenied: "Toegang tot camera of microfoon is geblokkeerd. Sta toegang toe in uw browserinstellingen of voeg een bestand bij.",
    recorderUnsupported: "Video-opname wordt niet ondersteund in deze browser. Probeer een videobestand bij te voegen.",
    recorderTooShort: "Die opname was te kort. Neem minstens één seconde op of probeer het opnieuw.",
    insertEmoji: "Emoji invoegen",
    dictateAnswer: "Antwoord inspreken",
    stopDictating: "Stop met inspreken",
    dictateMicError: "Microfoontoegang is geblokkeerd of spraakherkenning is mislukt. Controleer de browserrechten en probeer het opnieuw.",
    dictateMicDenied: "Microfoontoegang lijkt nog steeds geblokkeerd te zijn voor deze site. Als u de microfoon al hebt toegestaan in de site-instellingen van uw browser, vernieuw dan de pagina en probeer het opnieuw.",
    dictateNoSpeech: "Geen spraak gedetecteerd. Klik op de microfoon en probeer het opnieuw.",
    dictateConnecting: "Microfoon initialiseren… wacht even voordat u spreekt.",
    dictateListening: "Luisteren… spreek nu. Klik op de microfoon om te stoppen of op Verzenden als u klaar bent.",
    dictateStartTimeout: "Dicteren is niet op tijd gestart. Wacht even en probeer het opnieuw, of typ uw antwoord.",
    startingInterview: "Interview wordt gestart…",
    selectLanguage: "Taal",
    startInterview: "Interview starten",
    playQuestion: "Vraag afspelen",
    stopPlayback: "Afspelen stoppen",
    playbackError: "Dit bericht kon niet worden afgespeeld. Lees de tekst in plaats daarvan.",
  },
  fi: {
    answerPlaceholder: "Kirjoita vastauksesi ja/tai lataa mediaa. Paina Enter lähettääksesi, Shift+Enter uudelle riville",
    send: "Lähetä",
    thinking: "Ajattelee…",
    processingMedia: "Käsitellään mediaasi…",
    interviewComplete: "Kiitos — tämä haastattelu on valmis.",
    groupCompleteAwaitingEmail: "Kiitos tämän osan suorittamisesta. Lähetämme sinulle sähköpostia, kun seuraava osa on valmis.",
    groupCompleteAwaitingSaveLink: "Kiitos tämän osan suorittamisesta. Tallenna alla oleva linkki, jotta voit palata, kun seuraava osa on valmis.",
    saveLinkReminderTitle: "Tallenna tämä linkki",
    saveLinkReminderBody: "Tämä haastattelu jatkuu useiden päivien ajan. Käytä sähköpostitse saamaasi linkkiä, lisää tämä sivu kirjanmerkkeihin tai kopioi alla oleva linkki — tarvitset sitä palataksesi seuraavaan osaan.",
    saveLinkEmailDivider: "Tai saa ilmoitus sähköpostitse",
    saveLinkEmailHint: "Valinnainen. Lähetämme sinulle sähköpostia, kun seuraava osa on valmis, sen sijaan että luotat vain tähän linkkiin.",
    copyLink: "Kopioi linkki",
    linkCopied: "Linkki kopioitu",
    contactEmailLabel: "Sähköpostiosoite",
    contactEmailPlaceholder: "sinä@example.com",
    contactEmailRequired: "Anna kelvollinen sähköpostiosoite, jotta voimme ilmoittaa sinulle, kun seuraava osa on valmis.",
    saveContactEmail: "Tallenna sähköposti",
    contactEmailSaved: "Sähköposti tallennettu. Ilmoitamme sinulle, kun seuraava osa on valmis.",
    submitError: "Vastauksen lähetyksessä tapahtui virhe. Yritä uudelleen.",
    replyError: "Vastauksesi lähetettiin, mutta Maya ei voinut vastata. Yritä hetken kuluttua uudelleen.",
    removeAttachment: "Poista liite",
    attachmentPreviewRegion: "Liitteen esikatselu",
    reviewAttachmentBeforeSend: "Tarkista, että tämä on oikea tiedosto ennen lähettämistä.",
    reviewAttachmentsBeforeSend: "Tarkista, että nämä ovat oikeat tiedostot ennen lähettämistä.",
    reviewVideoBeforeSend: "Tarkista, että tämä on oikea video ennen lähettämistä.",
    reviewAudioBeforeSend: "Tarkista, että tämä on oikea äänitiedosto ennen lähettämistä.",
    uploadingMedia: "Ladataan…",
    cancelUpload: "Peruuta lataus",
    uploadCancelled: "Lataus peruutettu.",
    attachMedia: "Liitä media",
    mediaUploadHint: "Hyväksytyt tiedostotyypit: {types}. Enint. {maxSize}.",
    mediaUploadInvalidType: "Tätä tiedostotyyppiä ei tueta. Valitse jokin hyväksytyistä tiedostotyypeistä.",
    mediaUploadTooLarge: "Tiedosto on liian suuri. Suurin sallittu koko on {maxSize}.",
    mediaUploadTooMany: "Voit liittää enintään {max} tiedostoa viestiä kohden.",
    recordVideo: "Nauhoita video",
    recorderConsentBody: "Jatkamalla annat suostumuksesi siihen, että kameraasi ja mikrofoniasi käytetään videovastauksesi tallentamiseen. Tallenne tallennetaan turvallisesti muiden vastaustesi oheen, ja tutkimustiimi tarkastelee sen.",
    recorderConsentFallback: "Et halua nauhoittaa? Voit sen sijaan kirjoittaa, nauhoittaa ääntä tai liittää tiedoston.",
    recorderAccept: "Salli kamera ja mikrofoni",
    recorderDecline: "Ei nyt",
    recorderClose: "Sulje nauhuri",
    recorderStart: "Aloita nauhoitus",
    recorderStop: "Lopeta nauhoitus",
    recorderRetake: "Nauhoita uudelleen",
    recorderUse: "Käytä tätä videota",
    recorderRecording: "Nauhoitetaan",
    recorderPreparingCamera: "Valmistellaan kameraasi…",
    recorderReady: "Paina aloita, kun olet valmis nauhoittamaan.",
    recorderReview: "Tarkista nauhoituksesi ja käytä sitä tai nauhoita uudelleen.",
    recorderPermissionDenied: "Kameran tai mikrofonin käyttö estettiin. Salli käyttö selaimen asetuksissa tai liitä tiedosto sen sijaan.",
    recorderUnsupported: "Videonauhoitusta ei tueta tässä selaimessa. Kokeile liittää videotiedosto.",
    recorderTooShort: "Nauhoitus oli liian lyhyt. Nauhoita vähintään sekunnin verran tai yritä uudelleen.",
    insertEmoji: "Lisää emoji",
    dictateAnswer: "Sane vastaus",
    stopDictating: "Lopeta sanelu",
    dictateMicError: "Mikrofonin käyttö estettiin tai puheentunnistus epäonnistui. Tarkista selaimen käyttöoikeudet ja yritä uudelleen.",
    dictateMicDenied: "Mikrofonin käyttö näyttää olevan edelleen estetty tällä sivustolla. Jos olet jo sallinut mikrofonin selaimen sivustoasetuksissa, päivitä sivu ja yritä uudelleen.",
    dictateNoSpeech: "Puhetta ei havaittu. Napsauta mikrofonia ja yritä uudelleen.",
    dictateConnecting: "Alustetaan mikrofonia… odota hetki ennen puhumista.",
    dictateListening: "Kuunnellaan… puhu nyt. Napsauta mikrofonia lopettaaksesi tai Lähetä kun olet valmis.",
    dictateStartTimeout: "Sanelu ei käynnistynyt ajoissa. Odota hetki ja yritä uudelleen tai kirjoita vastauksesi.",
    startingInterview: "Haastattelu alkaa…",
    selectLanguage: "Kieli",
    startInterview: "Aloita haastattelu",
    playQuestion: "Toista kysymys",
    stopPlayback: "Lopeta toisto",
    playbackError: "Tätä viestiä ei voitu toistaa. Lue teksti sen sijaan.",
  },
  fr: {
    answerPlaceholder: "Saisissez votre réponse et/ou téléchargez un média. Appuyez sur Entrée pour envoyer, Maj+Entrée pour une nouvelle ligne",
    send: "Envoyer",
    thinking: "Réflexion en cours…",
    processingMedia: "Traitement de votre média…",
    interviewComplete: "Merci — cet entretien est terminé.",
    groupCompleteAwaitingEmail: "Merci d'avoir terminé cette partie. Nous vous enverrons un e-mail lorsque la partie suivante sera prête.",
    groupCompleteAwaitingSaveLink: "Merci d'avoir terminé cette partie. Enregistrez le lien ci-dessous pour pouvoir revenir lorsque la partie suivante sera prête.",
    saveLinkReminderTitle: "Enregistrez ce lien",
    saveLinkReminderBody: "Cet entretien se poursuit sur plusieurs jours. Utilisez le lien reçu par e-mail, ajoutez cette page à vos favoris ou copiez le lien ci-dessous — vous en aurez besoin pour revenir à la partie suivante.",
    saveLinkEmailDivider: "Ou recevez une notification par e-mail",
    saveLinkEmailHint: "Facultatif. Nous vous enverrons un e-mail lorsque la partie suivante sera prête, au lieu de vous fier uniquement à ce lien.",
    copyLink: "Copier le lien",
    linkCopied: "Lien copié",
    contactEmailLabel: "Adresse e-mail",
    contactEmailPlaceholder: "vous@exemple.com",
    contactEmailRequired: "Veuillez saisir une adresse e-mail valide afin que nous puissions vous informer lorsque la partie suivante sera prête.",
    saveContactEmail: "Enregistrer l'e-mail",
    contactEmailSaved: "E-mail enregistré. Nous vous informerons lorsque la partie suivante sera prête.",
    submitError: "Une erreur s'est produite lors de l'envoi de votre réponse. Veuillez réessayer.",
    replyError: "Votre réponse a été envoyée, mais Maya n'a pas pu répondre. Veuillez réessayer dans un instant.",
    removeAttachment: "Supprimer la pièce jointe",
    attachmentPreviewRegion: "Aperçu de la pièce jointe",
    reviewAttachmentBeforeSend: "Vérifiez qu'il s'agit du bon fichier avant d'envoyer.",
    reviewAttachmentsBeforeSend: "Vérifiez qu'il s'agit des bons fichiers avant d'envoyer.",
    reviewVideoBeforeSend: "Vérifiez qu'il s'agit de la bonne vidéo avant d'envoyer.",
    reviewAudioBeforeSend: "Vérifiez qu'il s'agit du bon fichier audio avant d'envoyer.",
    uploadingMedia: "Téléversement…",
    cancelUpload: "Annuler le téléversement",
    uploadCancelled: "Téléversement annulé.",
    attachMedia: "Joindre un média",
    mediaUploadHint: "Types de fichiers acceptés : {types}. Max. {maxSize}.",
    mediaUploadInvalidType: "Ce type de fichier n'est pas pris en charge. Choisissez l'un des types de fichiers acceptés.",
    mediaUploadTooLarge: "Ce fichier est trop volumineux. La taille maximale est {maxSize}.",
    mediaUploadTooMany: "Vous pouvez joindre jusqu'à {max} fichiers par message.",
    recordVideo: "Enregistrer une vidéo",
    recorderConsentBody: "En continuant, vous consentez à ce que votre caméra et votre microphone soient utilisés pour enregistrer votre réponse vidéo. Votre enregistrement sera stocké en toute sécurité avec vos autres réponses et examiné par l'équipe de recherche.",
    recorderConsentFallback: "Vous préférez ne pas enregistrer ? Vous pouvez taper, enregistrer de l'audio ou joindre un fichier à la place.",
    recorderAccept: "Autoriser la caméra et le microphone",
    recorderDecline: "Pas maintenant",
    recorderClose: "Fermer l'enregistreur",
    recorderStart: "Commencer l'enregistrement",
    recorderStop: "Arrêter l'enregistrement",
    recorderRetake: "Réenregistrer",
    recorderUse: "Utiliser cette vidéo",
    recorderRecording: "Enregistrement",
    recorderPreparingCamera: "Préparation de votre caméra…",
    recorderReady: "Appuyez sur démarrer lorsque vous êtes prêt à enregistrer.",
    recorderReview: "Vérifiez votre enregistrement, puis utilisez-le ou réenregistrez.",
    recorderPermissionDenied: "L'accès à la caméra ou au microphone a été bloqué. Autorisez l'accès dans les paramètres du navigateur ou joignez un fichier.",
    recorderUnsupported: "L'enregistrement vidéo n'est pas pris en charge dans ce navigateur. Essayez de joindre un fichier vidéo.",
    recorderTooShort: "Cet enregistrement était trop court. Enregistrez au moins une seconde ou réessayez.",
    insertEmoji: "Insérer un emoji",
    dictateAnswer: "Dicter la réponse",
    stopDictating: "Arrêter la dictée",
    dictateMicError: "L'accès au microphone a été bloqué ou la reconnaissance vocale a échoué. Vérifiez les autorisations du navigateur et réessayez.",
    dictateMicDenied: "L'accès au microphone semble toujours être bloqué pour ce site. Si vous avez déjà autorisé le microphone dans les paramètres du site de votre navigateur, actualisez simplement la page puis réessayez.",
    dictateNoSpeech: "Aucune parole détectée. Cliquez sur le micro et réessayez.",
    dictateConnecting: "Initialisation du microphone… attendez un instant avant de parler.",
    dictateListening: "Écoute en cours… parlez maintenant. Cliquez sur le micro pour arrêter ou sur Envoyer quand vous avez terminé.",
    dictateStartTimeout: "La dictée n'a pas démarré à temps. Attendez un instant et réessayez, ou saisissez votre réponse.",
    startingInterview: "Démarrage de l'entretien…",
    selectLanguage: "Langue",
    startInterview: "Commencer l'entretien",
    playQuestion: "Lire la question",
    stopPlayback: "Arrêter la lecture",
    playbackError: "Impossible de lire ce message. Veuillez lire le texte à la place.",
  },
  de: {
    answerPlaceholder: "Geben Sie Ihre Antwort ein und/oder laden Sie Medien hoch. Enter zum Senden, Umschalt+Enter für eine neue Zeile",
    send: "Senden",
    thinking: "Denkt nach…",
    processingMedia: "Ihre Medien werden verarbeitet…",
    interviewComplete: "Danke — dieses Interview ist abgeschlossen.",
    groupCompleteAwaitingEmail: "Vielen Dank für den Abschluss dieses Teils. Wir senden Ihnen eine E-Mail, wenn der nächste Teil bereit ist.",
    groupCompleteAwaitingSaveLink: "Vielen Dank für den Abschluss dieses Teils. Speichern Sie den untenstehenden Link, damit Sie zurückkehren können, wenn der nächste Teil bereit ist.",
    saveLinkReminderTitle: "Diesen Link speichern",
    saveLinkReminderBody: "Dieses Interview erstreckt sich über mehrere Tage. Verwenden Sie den per E-Mail gesendeten Link, setzen Sie ein Lesezeichen für diese Seite oder kopieren Sie den untenstehenden Link — Sie benötigen ihn, um für den nächsten Teil zurückzukehren.",
    saveLinkEmailDivider: "Oder per E-Mail benachrichtigt werden",
    saveLinkEmailHint: "Optional. Wir senden Ihnen eine E-Mail, wenn der nächste Teil bereit ist, anstatt sich nur auf diesen Link zu verlassen.",
    copyLink: "Link kopieren",
    linkCopied: "Link kopiert",
    contactEmailLabel: "E-Mail-Adresse",
    contactEmailPlaceholder: "sie@beispiel.com",
    contactEmailRequired: "Bitte geben Sie eine gültige E-Mail-Adresse ein, damit wir Sie benachrichtigen können, wenn der nächste Teil bereit ist.",
    saveContactEmail: "E-Mail speichern",
    contactEmailSaved: "E-Mail gespeichert. Wir benachrichtigen Sie, wenn der nächste Teil bereit ist.",
    submitError: "Beim Senden Ihrer Antwort ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
    replyError: "Ihre Antwort wurde gesendet, aber Maya konnte nicht antworten. Bitte versuchen Sie es gleich erneut.",
    removeAttachment: "Anhang entfernen",
    attachmentPreviewRegion: "Anhangsvorschau",
    reviewAttachmentBeforeSend: "Prüfen Sie, ob dies die richtige Datei ist, bevor Sie senden.",
    reviewAttachmentsBeforeSend: "Prüfen Sie, ob dies die richtigen Dateien sind, bevor Sie senden.",
    reviewVideoBeforeSend: "Prüfen Sie, ob dies das richtige Video ist, bevor Sie senden.",
    reviewAudioBeforeSend: "Prüfen Sie, ob dies die richtige Audiodatei ist, bevor Sie senden.",
    uploadingMedia: "Wird hochgeladen…",
    cancelUpload: "Upload abbrechen",
    uploadCancelled: "Upload abgebrochen.",
    attachMedia: "Medien anhängen",
    mediaUploadHint: "Akzeptierte Dateitypen: {types}. Max. {maxSize}.",
    mediaUploadInvalidType: "Dieser Dateityp wird nicht unterstützt. Bitte wählen Sie einen der akzeptierten Dateitypen.",
    mediaUploadTooLarge: "Diese Datei ist zu groß. Die maximale Upload-Größe beträgt {maxSize}.",
    mediaUploadTooMany: "Sie können bis zu {max} Dateien pro Nachricht anhängen.",
    recordVideo: "Video aufnehmen",
    recorderConsentBody: "Indem Sie fortfahren, stimmen Sie zu, dass Ihre Kamera und Ihr Mikrofon verwendet werden, um Ihre Videoantwort aufzunehmen. Ihre Aufnahme wird sicher zusammen mit Ihren anderen Antworten gespeichert und vom Forschungsteam eingesehen.",
    recorderConsentFallback: "Möchten Sie lieber nicht aufnehmen? Sie können stattdessen tippen, Audio aufnehmen oder eine Datei anhängen.",
    recorderAccept: "Kamera und Mikrofon erlauben",
    recorderDecline: "Nicht jetzt",
    recorderClose: "Recorder schließen",
    recorderStart: "Aufnahme starten",
    recorderStop: "Aufnahme stoppen",
    recorderRetake: "Erneut aufnehmen",
    recorderUse: "Dieses Video verwenden",
    recorderRecording: "Aufnahme",
    recorderPreparingCamera: "Ihre Kamera wird vorbereitet…",
    recorderReady: "Drücken Sie Start, wenn Sie bereit sind aufzunehmen.",
    recorderReview: "Überprüfen Sie Ihre Aufnahme und verwenden oder wiederholen Sie sie.",
    recorderPermissionDenied: "Der Zugriff auf Kamera oder Mikrofon wurde blockiert. Erlauben Sie den Zugriff in den Browsereinstellungen oder hängen Sie stattdessen eine Datei an.",
    recorderUnsupported: "Videoaufnahmen werden in diesem Browser nicht unterstützt. Versuchen Sie, eine Videodatei anzuhängen.",
    recorderTooShort: "Diese Aufnahme war zu kurz. Nehmen Sie mindestens eine Sekunde auf oder versuchen Sie es erneut.",
    insertEmoji: "Emoji einfügen",
    dictateAnswer: "Antwort diktieren",
    stopDictating: "Diktieren beenden",
    dictateMicError: "Der Mikrofonzugriff wurde blockiert oder die Spracherkennung ist fehlgeschlagen. Prüfen Sie die Browserberechtigungen und versuchen Sie es erneut.",
    dictateMicDenied: "Der Mikrofonzugriff scheint für diese Website noch blockiert zu sein. Wenn Sie das Mikrofon bereits in den Website-Einstellungen Ihres Browsers erlaubt haben, aktualisieren Sie bitte die Seite und versuchen Sie es erneut.",
    dictateNoSpeech: "Keine Sprache erkannt. Klicken Sie auf das Mikrofon und versuchen Sie es erneut.",
    dictateConnecting: "Mikrofon wird initialisiert… warten Sie einen Moment, bevor Sie sprechen.",
    dictateListening: "Hört zu… sprechen Sie jetzt. Klicken Sie auf das Mikrofon zum Stoppen oder auf Senden, wenn Sie fertig sind.",
    dictateStartTimeout: "Das Diktieren hat nicht rechtzeitig gestartet. Warten Sie einen Moment und versuchen Sie es erneut, oder tippen Sie Ihre Antwort.",
    startingInterview: "Interview wird gestartet…",
    selectLanguage: "Sprache",
    startInterview: "Interview starten",
    playQuestion: "Frage abspielen",
    stopPlayback: "Wiedergabe stoppen",
    playbackError: "Diese Nachricht konnte nicht abgespielt werden. Bitte lesen Sie stattdessen den Text.",
  },
  hi: {
    answerPlaceholder: "अपना उत्तर लिखें और/या मीडिया अपलोड करें। भेजने के लिए Enter दबाएँ, नई पंक्ति के लिए Shift+Enter",
    send: "भेजें",
    thinking: "सोच रहा है…",
    processingMedia: "आपका मीडिया प्रोसेस हो रहा है…",
    interviewComplete: "धन्यवाद — यह साक्षात्कार पूरा हो गया है।",
    groupCompleteAwaitingEmail: "इस भाग को पूरा करने के लिए धन्यवाद। अगला भाग तैयार होने पर हम आपको ईमेल करेंगे।",
    groupCompleteAwaitingSaveLink: "इस भाग को पूरा करने के लिए धन्यवाद। नीचे दिया गया लिंक सहेजें ताकि अगला भाग तैयार होने पर आप वापस आ सकें।",
    saveLinkReminderTitle: "इस लिंक को सहेजें",
    saveLinkReminderBody: "यह साक्षात्कार कई दिनों तक चलता है। ईमेल द्वारा भेजा गया लिंक उपयोग करें, इस पृष्ठ को बुकमार्क करें या नीचे दिया गया लिंक कॉपी करें — अगले भाग के लिए वापस आने के लिए आपको इसकी आवश्यकता होगी।",
    saveLinkEmailDivider: "या ईमेल द्वारा सूचना प्राप्त करें",
    saveLinkEmailHint: "वैकल्पिक। अगला भाग तैयार होने पर हम आपको ईमेल करेंगे, केवल इस लिंक पर निर्भर रहने के बजाय।",
    copyLink: "लिंक कॉपी करें",
    linkCopied: "लिंक कॉपी हो गया",
    contactEmailLabel: "ईमेल पता",
    contactEmailPlaceholder: "aap@udaharan.com",
    contactEmailRequired: "कृपया एक मान्य ईमेल पता दर्ज करें ताकि अगला भाग तैयार होने पर हम आपको सूचित कर सकें।",
    saveContactEmail: "ईमेल सहेजें",
    contactEmailSaved: "ईमेल सहेजा गया। अगला भाग तैयार होने पर हम आपको सूचित करेंगे।",
    submitError: "आपका उत्तर भेजते समय कुछ गलत हो गया। कृपया पुनः प्रयास करें।",
    replyError: "आपका उत्तर भेज दिया गया, लेकिन Maya उत्तर नहीं दे सकी। कृपया थोड़ी देर बाद पुनः प्रयास करें।",
    removeAttachment: "अटैचमेंट हटाएँ",
    attachmentPreviewRegion: "अटैचमेंट पूर्वावलोकन",
    reviewAttachmentBeforeSend: "भेजने से पहले जाँचें कि यह सही फ़ाइल है।",
    reviewAttachmentsBeforeSend: "भेजने से पहले जाँचें कि ये सही फ़ाइलें हैं।",
    reviewVideoBeforeSend: "भेजने से पहले जाँचें कि यह सही वीडियो है।",
    reviewAudioBeforeSend: "भेजने से पहले जाँचें कि यह सही ऑडियो है।",
    uploadingMedia: "अपलोड हो रहा है…",
    cancelUpload: "अपलोड रद्द करें",
    uploadCancelled: "अपलोड रद्द कर दिया गया।",
    attachMedia: "मीडिया संलग्न करें",
    mediaUploadHint: "स्वीकृत फ़ाइल प्रकार: {types}। अधिकतम {maxSize}।",
    mediaUploadInvalidType: "यह फ़ाइल प्रकार समर्थित नहीं है। कृपया स्वीकृत फ़ाइल प्रकारों में से एक चुनें।",
    mediaUploadTooLarge: "यह फ़ाइल बहुत बड़ी है। अधिकतम अपलोड आकार {maxSize} है।",
    mediaUploadTooMany: "आप प्रति संदेश अधिकतम {max} फ़ाइलें संलग्न कर सकते हैं।",
    recordVideo: "वीडियो रिकॉर्ड करें",
    recorderConsentBody: "आगे बढ़कर, आप अपने वीडियो उत्तर को रिकॉर्ड करने के लिए अपने कैमरे और माइक्रोफ़ोन के उपयोग की सहमति देते हैं। आपकी रिकॉर्डिंग आपके अन्य उत्तरों के साथ सुरक्षित रूप से संग्रहीत की जाएगी और शोध टीम द्वारा समीक्षा की जाएगी।",
    recorderConsentFallback: "रिकॉर्ड नहीं करना चाहते? आप इसके बजाय टाइप कर सकते हैं, ऑडियो रिकॉर्ड कर सकते हैं या फ़ाइल संलग्न कर सकते हैं।",
    recorderAccept: "कैमरा और माइक्रोफ़ोन की अनुमति दें",
    recorderDecline: "अभी नहीं",
    recorderClose: "रिकॉर्डर बंद करें",
    recorderStart: "रिकॉर्डिंग शुरू करें",
    recorderStop: "रिकॉर्डिंग रोकें",
    recorderRetake: "फिर से रिकॉर्ड करें",
    recorderUse: "यह वीडियो उपयोग करें",
    recorderRecording: "रिकॉर्डिंग",
    recorderPreparingCamera: "आपका कैमरा तैयार किया जा रहा है…",
    recorderReady: "जब आप रिकॉर्ड करने के लिए तैयार हों तो प्रारंभ दबाएँ।",
    recorderReview: "अपनी रिकॉर्डिंग की समीक्षा करें, फिर इसे उपयोग करें या फिर से रिकॉर्ड करें।",
    recorderPermissionDenied: "कैमरा या माइक्रोफ़ोन एक्सेस अवरुद्ध था। ब्राउज़र सेटिंग में अनुमति दें, या इसके बजाय फ़ाइल संलग्न करें।",
    recorderUnsupported: "इस ब्राउज़र में वीडियो रिकॉर्डिंग समर्थित नहीं है। वीडियो फ़ाइल संलग्न करने का प्रयास करें।",
    recorderTooShort: "वह रिकॉर्डिंग बहुत छोटी थी। कम से कम एक सेकंड रिकॉर्ड करें, या पुनः प्रयास करें।",
    insertEmoji: "इमोजी डालें",
    dictateAnswer: "उत्तर बोलें",
    stopDictating: "बोलना बंद करें",
    dictateMicError: "माइक्रोफ़ोन एक्सेस ब्लॉक हो गया या स्पीच रिकग्निशन विफल रहा। ब्राउज़र अनुमतियाँ जाँचें और पुनः प्रयास करें।",
    dictateMicDenied: "इस साइट के लिए माइक्रोफ़ोन एक्सेस अभी भी ब्लॉक लग रहा है। यदि आपने पहले ही ब्राउज़र की साइट सेटिंग में माइक्रोफ़ोन की अनुमति दे दी है, तो कृपया अपना पेज रीफ़्रेश करें और फिर पुनः प्रयास करें।",
    dictateNoSpeech: "कोई आवाज़ नहीं मिली। माइक पर क्लिक करें और पुनः प्रयास करें।",
    dictateConnecting: "माइक्रोफ़ोन प्रारंभ किया जा रहा है… बोलने से पहले कुछ क्षण प्रतीक्षा करें।",
    dictateListening: "सुन रहा है… अभी बोलें। रोकने के लिए माइक पर क्लिक करें या हो जाने पर भेजें दबाएँ।",
    dictateStartTimeout: "डिक्टेशन समय पर शुरू नहीं हुआ। कुछ क्षण प्रतीक्षा करें और पुनः प्रयास करें, या अपना उत्तर टाइप करें।",
    startingInterview: "साक्षात्कार शुरू हो रहा है…",
    selectLanguage: "भाषा",
    startInterview: "साक्षात्कार शुरू करें",
    playQuestion: "प्रश्न चलाएँ",
    stopPlayback: "प्लेबैक रोकें",
    playbackError: "यह संदेश चलाया नहीं जा सका। कृपया इसके बजाय पाठ पढ़ें।",
  },
  it: {
    answerPlaceholder: "Scrivi la tua risposta e/o carica un file multimediale. Premi Invio per inviare, Maiusc+Invio per una nuova riga",
    send: "Invia",
    thinking: "Sta pensando…",
    processingMedia: "Elaborazione del tuo file multimediale…",
    interviewComplete: "Grazie — questo colloquio è completo.",
    groupCompleteAwaitingEmail: "Grazie per aver completato questa parte. Ti invieremo un'e-mail quando la parte successiva sarà pronta.",
    groupCompleteAwaitingSaveLink: "Grazie per aver completato questa parte. Salva il link qui sotto per poter tornare quando la parte successiva sarà pronta.",
    saveLinkReminderTitle: "Salva questo link",
    saveLinkReminderBody: "Questo colloquio si svolge su più giorni. Usa il link ricevuto via e-mail, aggiungi questa pagina ai preferiti o copia il link qui sotto — ti servirà per tornare alla parte successiva.",
    saveLinkEmailDivider: "Oppure ricevi una notifica via e-mail",
    saveLinkEmailHint: "Facoltativo. Ti invieremo un'e-mail quando la parte successiva sarà pronta, invece di affidarti solo a questo link.",
    copyLink: "Copia link",
    linkCopied: "Link copiato",
    contactEmailLabel: "Indirizzo e-mail",
    contactEmailPlaceholder: "tu@esempio.com",
    contactEmailRequired: "Inserisci un indirizzo e-mail valido così possiamo avvisarti quando la parte successiva sarà pronta.",
    saveContactEmail: "Salva e-mail",
    contactEmailSaved: "E-mail salvata. Ti avviseremo quando la parte successiva sarà pronta.",
    submitError: "Si è verificato un errore durante l'invio della risposta. Riprova.",
    replyError: "La tua risposta è stata inviata, ma Maya non ha potuto rispondere. Riprova tra un momento.",
    removeAttachment: "Rimuovi allegato",
    attachmentPreviewRegion: "Anteprima allegato",
    reviewAttachmentBeforeSend: "Controlla che sia il file giusto prima di inviare.",
    reviewAttachmentsBeforeSend: "Controlla che siano i file giusti prima di inviare.",
    reviewVideoBeforeSend: "Controlla che sia il video giusto prima di inviare.",
    reviewAudioBeforeSend: "Controlla che sia l'audio giusto prima di inviare.",
    uploadingMedia: "Caricamento…",
    cancelUpload: "Annulla caricamento",
    uploadCancelled: "Caricamento annullato.",
    attachMedia: "Allega media",
    mediaUploadHint: "Tipi di file accettati: {types}. Max {maxSize}.",
    mediaUploadInvalidType: "Questo tipo di file non è supportato. Scegli uno dei tipi di file accettati.",
    mediaUploadTooLarge: "Questo file è troppo grande. La dimensione massima è {maxSize}.",
    mediaUploadTooMany: "Puoi allegare fino a {max} file per messaggio.",
    recordVideo: "Registra video",
    recorderConsentBody: "Continuando, acconsenti all'uso della fotocamera e del microfono per registrare la tua risposta video. La registrazione verrà archiviata in modo sicuro insieme alle altre risposte ed esaminata dal team di ricerca.",
    recorderConsentFallback: "Preferisci non registrare? Puoi invece digitare, registrare audio o allegare un file.",
    recorderAccept: "Consenti fotocamera e microfono",
    recorderDecline: "Non ora",
    recorderClose: "Chiudi registratore",
    recorderStart: "Avvia registrazione",
    recorderStop: "Interrompi registrazione",
    recorderRetake: "Registra di nuovo",
    recorderUse: "Usa questo video",
    recorderRecording: "Registrazione",
    recorderPreparingCamera: "Preparazione della fotocamera…",
    recorderReady: "Premi avvia quando sei pronto a registrare.",
    recorderReview: "Rivedi la registrazione, poi usala o registra di nuovo.",
    recorderPermissionDenied: "L'accesso a fotocamera o microfono è stato bloccato. Consenti l'accesso nelle impostazioni del browser o allega un file.",
    recorderUnsupported: "La registrazione video non è supportata in questo browser. Prova ad allegare un file video.",
    recorderTooShort: "Quella registrazione era troppo breve. Registra per almeno un secondo o riprova.",
    insertEmoji: "Inserisci emoji",
    dictateAnswer: "Detta la risposta",
    stopDictating: "Interrompi dettatura",
    dictateMicError: "L'accesso al microfono è stato bloccato o il riconoscimento vocale non è riuscito. Controlla le autorizzazioni del browser e riprova.",
    dictateMicDenied: "L'accesso al microfono sembra essere ancora bloccato per questo sito. Se hai già consentito il microfono nelle impostazioni del sito del browser, aggiorna la pagina e riprova.",
    dictateNoSpeech: "Nessun parlato rilevato. Fai clic sul microfono e riprova.",
    dictateConnecting: "Inizializzazione del microfono… attendi un momento prima di parlare.",
    dictateListening: "In ascolto… parla ora. Clicca sul microfono per fermare o su Invia quando hai finito.",
    dictateStartTimeout: "La dettatura non è partita in tempo. Attendi un momento e riprova, oppure digita la risposta.",
    startingInterview: "Avvio del colloquio…",
    selectLanguage: "Lingua",
    startInterview: "Inizia colloquio",
    playQuestion: "Riproduci domanda",
    stopPlayback: "Interrompi riproduzione",
    playbackError: "Impossibile riprodurre questo messaggio. Leggi il testo invece.",
  },
  ja: {
    answerPlaceholder: "回答を入力するか、メディアをアップロードしてください。Enterで送信、Shift+Enterで改行",
    send: "送信",
    thinking: "考え中…",
    processingMedia: "メディアを処理しています…",
    interviewComplete: "ありがとうございます — インタビューは完了しました。",
    groupCompleteAwaitingEmail: "このパートを完了していただきありがとうございます。次のパートの準備ができ次第、メールでお知らせします。",
    groupCompleteAwaitingSaveLink: "このパートを完了していただきありがとうございます。次のパートの準備ができたときに戻れるよう、下のリンクを保存してください。",
    saveLinkReminderTitle: "このリンクを保存",
    saveLinkReminderBody: "このインタビューは複数日にわたって続きます。メールで送られたリンクを使用するか、このページをブックマークするか、下のリンクをコピーしてください — 次のパートに戻るために必要です。",
    saveLinkEmailDivider: "またはメールで通知を受け取る",
    saveLinkEmailHint: "任意。このリンクだけに頼らず、次のパートの準備ができたらメールでお知らせします。",
    copyLink: "リンクをコピー",
    linkCopied: "リンクをコピーしました",
    contactEmailLabel: "メールアドレス",
    contactEmailPlaceholder: "you@example.com",
    contactEmailRequired: "次のパートの準備ができたときにお知らせできるよう、有効なメールアドレスを入力してください。",
    saveContactEmail: "メールを保存",
    contactEmailSaved: "メールを保存しました。次のパートの準備ができたらお知らせします。",
    submitError: "回答の送信中にエラーが発生しました。もう一度お試しください。",
    replyError: "回答は送信されましたが、Maya から返信できませんでした。しばらくしてからもう一度お試しください。",
    removeAttachment: "添付ファイルを削除",
    attachmentPreviewRegion: "添付ファイルのプレビュー",
    reviewAttachmentBeforeSend: "送信前に正しいファイルか確認してください。",
    reviewAttachmentsBeforeSend: "送信前に正しいファイルか確認してください。",
    reviewVideoBeforeSend: "送信前に正しい動画か確認してください。",
    reviewAudioBeforeSend: "送信前に正しい音声か確認してください。",
    uploadingMedia: "アップロード中…",
    cancelUpload: "アップロードをキャンセル",
    uploadCancelled: "アップロードをキャンセルしました。",
    attachMedia: "メディアを添付",
    mediaUploadHint: "アップロード可能なファイル形式：{types}。最大 {maxSize}。",
    mediaUploadInvalidType: "このファイル形式はサポートされていません。利用可能なファイル形式を選択してください。",
    mediaUploadTooLarge: "ファイルが大きすぎます。最大アップロードサイズは {maxSize} です。",
    mediaUploadTooMany: "1件のメッセージに最大 {max} 個のファイルを添付できます。",
    recordVideo: "動画を録画",
    recorderConsentBody: "続行すると、動画回答を録画するためにカメラとマイクを使用することに同意したことになります。録画内容は他の回答とともに安全に保存され、調査チームが確認します。",
    recorderConsentFallback: "録画したくない場合は、代わりに入力、音声録音、またはファイルの添付ができます。",
    recorderAccept: "カメラとマイクを許可",
    recorderDecline: "後で",
    recorderClose: "録画を閉じる",
    recorderStart: "録画を開始",
    recorderStop: "録画を停止",
    recorderRetake: "再録画",
    recorderUse: "この動画を使用",
    recorderRecording: "録画中",
    recorderPreparingCamera: "カメラを準備しています…",
    recorderReady: "録画の準備ができたら開始を押してください。",
    recorderReview: "録画を確認し、使用するか再録画してください。",
    recorderPermissionDenied: "カメラまたはマイクへのアクセスがブロックされました。ブラウザ設定で許可するか、ファイルを添付してください。",
    recorderUnsupported: "このブラウザでは動画録画はサポートされていません。動画ファイルを添付してください。",
    recorderTooShort: "録画が短すぎます。少なくとも1秒録画するか、もう一度お試しください。",
    insertEmoji: "絵文字を挿入",
    dictateAnswer: "音声で回答を入力",
    stopDictating: "音声入力を停止",
    dictateMicError: "マイクへのアクセスがブロックされたか、音声認識に失敗しました。ブラウザの権限を確認して、もう一度お試しください。",
    dictateMicDenied: "このサイトのマイクアクセスはまだブロックされているようです。ブラウザのサイト設定でマイクをすでに許可している場合は、ページを更新してからもう一度お試しください。",
    dictateNoSpeech: "音声が検出されませんでした。マイクをクリックしてもう一度お試しください。",
    dictateConnecting: "マイクを初期化しています…話す前に少しお待ちください。",
    dictateListening: "聞いています…今話してください。停止するにはマイクを、完了したら送信をクリックしてください。",
    dictateStartTimeout: "音声入力が時間内に開始されませんでした。少し待ってから再試行するか、回答を入力してください。",
    startingInterview: "インタビューを開始しています…",
    selectLanguage: "言語",
    startInterview: "インタビューを開始",
    playQuestion: "質問を再生",
    stopPlayback: "再生を停止",
    playbackError: "このメッセージを再生できませんでした。代わりにテキストをお読みください。",
  },
  ko: {
    answerPlaceholder: "답변을 입력하거나 미디어를 업로드하세요. Enter로 보내기, Shift+Enter로 줄 바꿈",
    send: "보내기",
    thinking: "생각 중…",
    processingMedia: "미디어를 처리하는 중…",
    interviewComplete: "감사합니다 — 인터뷰가 완료되었습니다.",
    groupCompleteAwaitingEmail: "이 부분을 완료해 주셔서 감사합니다. 다음 부분이 준비되면 이메일로 알려드리겠습니다.",
    groupCompleteAwaitingSaveLink: "이 부분을 완료해 주셔서 감사합니다. 다음 부분이 준비되었을 때 돌아올 수 있도록 아래 링크를 저장하세요.",
    saveLinkReminderTitle: "이 링크 저장",
    saveLinkReminderBody: "이 인터뷰는 여러 날에 걸쳐 진행됩니다. 이메일로 받은 링크를 사용하거나, 이 페이지를 북마크하거나, 아래 링크를 복사하세요 — 다음 부분으로 돌아오려면 필요합니다.",
    saveLinkEmailDivider: "또는 이메일로 알림 받기",
    saveLinkEmailHint: "선택 사항. 이 링크에만 의존하지 않고 다음 부분이 준비되면 이메일로 알려드립니다.",
    copyLink: "링크 복사",
    linkCopied: "링크가 복사되었습니다",
    contactEmailLabel: "이메일 주소",
    contactEmailPlaceholder: "you@example.com",
    contactEmailRequired: "다음 부분이 준비되면 알려드릴 수 있도록 유효한 이메일 주소를 입력해 주세요.",
    saveContactEmail: "이메일 저장",
    contactEmailSaved: "이메일이 저장되었습니다. 다음 부분이 준비되면 알려드리겠습니다.",
    submitError: "답변을 보내는 중 오류가 발생했습니다. 다시 시도해 주세요.",
    replyError: "답변은 전송되었지만 Maya가 응답하지 못했습니다. 잠시 후 다시 시도해 주세요.",
    removeAttachment: "첨부 파일 제거",
    attachmentPreviewRegion: "첨부 파일 미리보기",
    reviewAttachmentBeforeSend: "보내기 전에 올바른 파일인지 확인하세요.",
    reviewAttachmentsBeforeSend: "보내기 전에 올바른 파일인지 확인하세요.",
    reviewVideoBeforeSend: "보내기 전에 올바른 동영상인지 확인하세요.",
    reviewAudioBeforeSend: "보내기 전에 올바른 오디오인지 확인하세요.",
    uploadingMedia: "업로드 중…",
    cancelUpload: "업로드 취소",
    uploadCancelled: "업로드가 취소되었습니다.",
    attachMedia: "미디어 첨부",
    mediaUploadHint: "허용되는 파일 형식: {types}. 최대 {maxSize}.",
    mediaUploadInvalidType: "지원되지 않는 파일 형식입니다. 허용되는 파일 형식 중 하나를 선택하세요.",
    mediaUploadTooLarge: "파일이 너무 큽니다. 최대 업로드 크기는 {maxSize}입니다.",
    mediaUploadTooMany: "메시지당 최대 {max}개의 파일을 첨부할 수 있습니다.",
    recordVideo: "동영상 녹화",
    recorderConsentBody: "계속하면 동영상 답변을 녹화하기 위해 카메라와 마이크를 사용하는 데 동의하게 됩니다. 녹화본은 다른 답변과 함께 안전하게 저장되며 연구팀이 검토합니다.",
    recorderConsentFallback: "녹화를 원하지 않으시나요? 대신 입력, 오디오 녹음 또는 파일 첨부를 할 수 있습니다.",
    recorderAccept: "카메라 및 마이크 허용",
    recorderDecline: "나중에",
    recorderClose: "녹화기 닫기",
    recorderStart: "녹화 시작",
    recorderStop: "녹화 중지",
    recorderRetake: "다시 녹화",
    recorderUse: "이 동영상 사용",
    recorderRecording: "녹화 중",
    recorderPreparingCamera: "카메라를 준비하는 중…",
    recorderReady: "녹화할 준비가 되면 시작을 누르세요.",
    recorderReview: "녹화본을 확인한 후 사용하거나 다시 녹화하세요.",
    recorderPermissionDenied: "카메라 또는 마이크 액세스가 차단되었습니다. 브라우저 설정에서 허용하거나 파일을 첨부하세요.",
    recorderUnsupported: "이 브라우저에서는 동영상 녹화가 지원되지 않습니다. 동영상 파일을 첨부해 보세요.",
    recorderTooShort: "녹화가 너무 짧습니다. 최소 1초 이상 녹화하거나 다시 시도하세요.",
    insertEmoji: "이모지 삽입",
    dictateAnswer: "답변 음성 입력",
    stopDictating: "음성 입력 중지",
    dictateMicError: "마이크 액세스가 차단되었거나 음성 인식에 실패했습니다. 브라우저 권한을 확인한 후 다시 시도해 주세요.",
    dictateMicDenied: "이 사이트의 마이크 액세스가 여전히 차단된 것 같습니다. 브라우저 사이트 설정에서 이미 마이크를 허용했다면 페이지를 새로고침한 후 다시 시도해 주세요.",
    dictateNoSpeech: "음성이 감지되지 않았습니다. 마이크를 클릭하고 다시 시도하세요.",
    dictateConnecting: "마이크를 초기화하는 중… 말하기 전에 잠시 기다려 주세요.",
    dictateListening: "듣는 중… 지금 말하세요. 중지하려면 마이크를, 완료되면 보내기를 클릭하세요.",
    dictateStartTimeout: "음성 입력이 제시간에 시작되지 않았습니다. 잠시 후 다시 시도하거나 답변을 입력해 주세요.",
    startingInterview: "인터뷰를 시작하는 중…",
    selectLanguage: "언어",
    startInterview: "인터뷰 시작",
    playQuestion: "질문 재생",
    stopPlayback: "재생 중지",
    playbackError: "이 메시지를 재생할 수 없습니다. 대신 텍스트를 읽어 주세요.",
  },
  pl: {
    answerPlaceholder: "Wpisz odpowiedź i/lub prześlij multimedia. Enter, aby wysłać, Shift+Enter dla nowej linii",
    send: "Wyślij",
    thinking: "Myślę…",
    processingMedia: "Przetwarzanie multimediów…",
    interviewComplete: "Dziękujemy — ta rozmowa została zakończona.",
    groupCompleteAwaitingEmail: "Dziękujemy za ukończenie tej części. Wyślemy Ci e-mail, gdy następna część będzie gotowa.",
    groupCompleteAwaitingSaveLink: "Dziękujemy za ukończenie tej części. Zapisz poniższy link, aby móc wrócić, gdy następna część będzie gotowa.",
    saveLinkReminderTitle: "Zapisz ten link",
    saveLinkReminderBody: "Ta rozmowa trwa przez kilka dni. Użyj linku wysłanego e-mailem, dodaj tę stronę do zakładek lub skopiuj poniższy link — będziesz go potrzebować, aby wrócić do następnej części.",
    saveLinkEmailDivider: "Lub otrzymuj powiadomienia e-mailem",
    saveLinkEmailHint: "Opcjonalnie. Wyślemy Ci e-mail, gdy następna część będzie gotowa, zamiast polegać wyłącznie na tym linku.",
    copyLink: "Kopiuj link",
    linkCopied: "Link skopiowany",
    contactEmailLabel: "Adres e-mail",
    contactEmailPlaceholder: "ty@przyklad.com",
    contactEmailRequired: "Podaj prawidłowy adres e-mail, abyśmy mogli powiadomić Cię, gdy następna część będzie gotowa.",
    saveContactEmail: "Zapisz e-mail",
    contactEmailSaved: "E-mail zapisany. Powiadomimy Cię, gdy następna część będzie gotowa.",
    submitError: "Wystąpił błąd podczas wysyłania odpowiedzi. Spróbuj ponownie.",
    replyError: "Twoja odpowiedź została wysłana, ale Maya nie mogła odpowiedzieć. Spróbuj ponownie za chwilę.",
    removeAttachment: "Usuń załącznik",
    attachmentPreviewRegion: "Podgląd załącznika",
    reviewAttachmentBeforeSend: "Sprawdź, czy to właściwy plik, zanim wyślesz.",
    reviewAttachmentsBeforeSend: "Sprawdź, czy to właściwe pliki, zanim wyślesz.",
    reviewVideoBeforeSend: "Sprawdź, czy to właściwe wideo, zanim wyślesz.",
    reviewAudioBeforeSend: "Sprawdź, czy to właściwy plik audio, zanim wyślesz.",
    uploadingMedia: "Przesyłanie…",
    cancelUpload: "Anuluj przesyłanie",
    uploadCancelled: "Przesyłanie anulowane.",
    attachMedia: "Dołącz multimedia",
    mediaUploadHint: "Akceptowane typy plików: {types}. Maks. {maxSize}.",
    mediaUploadInvalidType: "Ten typ pliku nie jest obsługiwany. Wybierz jeden z akceptowanych typów plików.",
    mediaUploadTooLarge: "Ten plik jest za duży. Maksymalny rozmiar przesyłania to {maxSize}.",
    mediaUploadTooMany: "Możesz dołączyć do {max} plików na wiadomość.",
    recordVideo: "Nagraj wideo",
    recorderConsentBody: "Kontynuując, wyrażasz zgodę na użycie kamery i mikrofonu do nagrania odpowiedzi wideo. Nagranie zostanie bezpiecznie przechowane wraz z innymi odpowiedziami i przejrzane przez zespół badawczy.",
    recorderConsentFallback: "Wolisz nie nagrywać? Możesz zamiast tego wpisać odpowiedź, nagrać audio lub dołączyć plik.",
    recorderAccept: "Zezwól na kamerę i mikrofon",
    recorderDecline: "Nie teraz",
    recorderClose: "Zamknij rejestrator",
    recorderStart: "Rozpocznij nagrywanie",
    recorderStop: "Zatrzymaj nagrywanie",
    recorderRetake: "Nagraj ponownie",
    recorderUse: "Użyj tego wideo",
    recorderRecording: "Nagrywanie",
    recorderPreparingCamera: "Przygotowywanie kamery…",
    recorderReady: "Naciśnij start, gdy będziesz gotowy do nagrania.",
    recorderReview: "Obejrzyj nagranie, a następnie użyj go lub nagraj ponownie.",
    recorderPermissionDenied: "Dostęp do kamery lub mikrofonu został zablokowany. Zezwól na dostęp w ustawieniach przeglądarki lub dołącz plik.",
    recorderUnsupported: "Nagrywanie wideo nie jest obsługiwane w tej przeglądarce. Spróbuj dołączyć plik wideo.",
    recorderTooShort: "To nagranie było za krótkie. Nagraj co najmniej jedną sekundę lub spróbuj ponownie.",
    insertEmoji: "Wstaw emoji",
    dictateAnswer: "Dyktuj odpowiedź",
    stopDictating: "Zatrzymaj dyktowanie",
    dictateMicError: "Dostęp do mikrofonu został zablokowany lub rozpoznawanie mowy nie powiodło się. Sprawdź uprawnienia przeglądarki i spróbuj ponownie.",
    dictateMicDenied: "Dostęp do mikrofonu wydaje się nadal być zablokowany dla tej witryny. Jeśli już zezwoliłeś na mikrofon w ustawieniach witryny przeglądarki, odśwież stronę i spróbuj ponownie.",
    dictateNoSpeech: "Nie wykryto mowy. Kliknij mikrofon i spróbuj ponownie.",
    dictateConnecting: "Inicjowanie mikrofonu… zaczekaj chwilę przed mówieniem.",
    dictateListening: "Nasłuchiwanie… mów teraz. Kliknij mikrofon, aby zatrzymać, lub Wyślij, gdy skończysz.",
    dictateStartTimeout: "Dyktowanie nie rozpoczęło się na czas. Zaczekaj chwilę i spróbuj ponownie lub wpisz odpowiedź.",
    startingInterview: "Rozpoczynanie rozmowy…",
    selectLanguage: "Język",
    startInterview: "Rozpocznij rozmowę",
    playQuestion: "Odtwórz pytanie",
    stopPlayback: "Zatrzymaj odtwarzanie",
    playbackError: "Nie można odtworzyć tej wiadomości. Przeczytaj tekst zamiast tego.",
  },
  pt: {
    answerPlaceholder: "Digite sua resposta e/ou envie mídia. Pressione Enter para enviar, Shift+Enter para nova linha",
    send: "Enviar",
    thinking: "Pensando…",
    processingMedia: "Processando sua mídia…",
    interviewComplete: "Obrigado — esta entrevista foi concluída.",
    groupCompleteAwaitingEmail: "Obrigado por concluir esta parte. Enviaremos um e-mail quando a próxima parte estiver pronta.",
    groupCompleteAwaitingSaveLink: "Obrigado por concluir esta parte. Guarde a ligação abaixo para poder regressar quando a próxima parte estiver pronta.",
    saveLinkReminderTitle: "Guarde esta ligação",
    saveLinkReminderBody: "Esta entrevista continua ao longo de vários dias. Use a ligação enviada por e-mail, adicione esta página aos favoritos ou copie a ligação abaixo — precisará dela para regressar à próxima parte.",
    saveLinkEmailDivider: "Ou receba notificação por e-mail",
    saveLinkEmailHint: "Opcional. Enviaremos um e-mail quando a próxima parte estiver pronta, em vez de depender apenas desta ligação.",
    copyLink: "Copiar ligação",
    linkCopied: "Ligação copiada",
    contactEmailLabel: "Endereço de e-mail",
    contactEmailPlaceholder: "voce@exemplo.com",
    contactEmailRequired: "Introduza um endereço de e-mail válido para podermos notificá-lo quando a próxima parte estiver pronta.",
    saveContactEmail: "Guardar e-mail",
    contactEmailSaved: "E-mail guardado. Notificá-lo-emos quando a próxima parte estiver pronta.",
    submitError: "Algo deu errado ao enviar sua resposta. Tente novamente.",
    replyError: "Sua resposta foi enviada, mas a Maya não conseguiu responder. Tente novamente em instantes.",
    removeAttachment: "Remover anexo",
    attachmentPreviewRegion: "Pré-visualização do anexo",
    reviewAttachmentBeforeSend: "Verifique se este é o ficheiro correto antes de enviar.",
    reviewAttachmentsBeforeSend: "Verifique se estes são os ficheiros corretos antes de enviar.",
    reviewVideoBeforeSend: "Verifique se este é o vídeo correto antes de enviar.",
    reviewAudioBeforeSend: "Verifique se este é o áudio correto antes de enviar.",
    uploadingMedia: "A enviar…",
    cancelUpload: "Cancelar envio",
    uploadCancelled: "Envio cancelado.",
    attachMedia: "Anexar mídia",
    mediaUploadHint: "Tipos de ficheiro aceites: {types}. Máx. {maxSize}.",
    mediaUploadInvalidType: "Esse tipo de ficheiro não é suportado. Escolha um dos tipos de ficheiro aceites.",
    mediaUploadTooLarge: "Esse ficheiro é demasiado grande. O tamanho máximo de envio é {maxSize}.",
    mediaUploadTooMany: "Pode anexar até {max} ficheiros por mensagem.",
    recordVideo: "Gravar vídeo",
    recorderConsentBody: "Ao continuar, consente que a sua câmara e microfone sejam utilizados para gravar a sua resposta em vídeo. A gravação será armazenada em segurança com as suas outras respostas e revista pela equipa de investigação.",
    recorderConsentFallback: "Prefere não gravar? Pode escrever, gravar áudio ou anexar um ficheiro em alternativa.",
    recorderAccept: "Permitir câmara e microfone",
    recorderDecline: "Agora não",
    recorderClose: "Fechar gravador",
    recorderStart: "Iniciar gravação",
    recorderStop: "Parar gravação",
    recorderRetake: "Gravar novamente",
    recorderUse: "Usar este vídeo",
    recorderRecording: "A gravar",
    recorderPreparingCamera: "A preparar a sua câmara…",
    recorderReady: "Prima iniciar quando estiver pronto para gravar.",
    recorderReview: "Reveja a gravação e depois use-a ou grave novamente.",
    recorderPermissionDenied: "O acesso à câmara ou ao microfone foi bloqueado. Permita o acesso nas definições do navegador ou anexe um ficheiro.",
    recorderUnsupported: "A gravação de vídeo não é suportada neste navegador. Tente anexar um ficheiro de vídeo.",
    recorderTooShort: "Essa gravação foi demasiado curta. Grave pelo menos um segundo ou tente novamente.",
    insertEmoji: "Inserir emoji",
    dictateAnswer: "Ditar resposta",
    stopDictating: "Parar ditado",
    dictateMicError: "O acesso ao microfone foi bloqueado ou o reconhecimento de voz falhou. Verifique as permissões do navegador e tente novamente.",
    dictateMicDenied: "O acesso ao microfone parece ainda estar bloqueado para este site. Se já permitiu o microfone nas definições do site do navegador, atualize a página e tente novamente.",
    dictateNoSpeech: "Nenhuma fala detetada. Clique no microfone e tente novamente.",
    dictateConnecting: "A inicializar o microfone… aguarde um momento antes de falar.",
    dictateListening: "A ouvir… fale agora. Clique no microfone para parar ou em Enviar quando terminar.",
    dictateStartTimeout: "O ditado não começou a tempo. Aguarde um momento e tente novamente, ou escreva a resposta.",
    startingInterview: "Iniciando entrevista…",
    selectLanguage: "Idioma",
    startInterview: "Iniciar entrevista",
    playQuestion: "Reproduzir pergunta",
    stopPlayback: "Parar reprodução",
    playbackError: "Não foi possível reproduzir esta mensagem. Leia o texto em alternativa.",
  },
  es: {
    answerPlaceholder: "Escribe tu respuesta y/o sube un archivo multimedia. Pulsa Enter para enviar, Mayús+Enter para una nueva línea",
    send: "Enviar",
    thinking: "Pensando…",
    processingMedia: "Procesando tu archivo multimedia…",
    interviewComplete: "Gracias — esta entrevista ha finalizado.",
    groupCompleteAwaitingEmail: "Gracias por completar esta parte. Te enviaremos un correo electrónico cuando la siguiente parte esté lista.",
    groupCompleteAwaitingSaveLink: "Gracias por completar esta parte. Guarda el enlace de abajo para poder volver cuando la siguiente parte esté lista.",
    saveLinkReminderTitle: "Guarda este enlace",
    saveLinkReminderBody: "Esta entrevista continúa durante varios días. Usa el enlace que recibiste por correo electrónico, guarda esta página en favoritos o copia el enlace de abajo — lo necesitarás para volver a la siguiente parte.",
    saveLinkEmailDivider: "O recibe una notificación por correo electrónico",
    saveLinkEmailHint: "Opcional. Te enviaremos un correo electrónico cuando la siguiente parte esté lista, en lugar de depender solo de este enlace.",
    copyLink: "Copiar enlace",
    linkCopied: "Enlace copiado",
    contactEmailLabel: "Dirección de correo electrónico",
    contactEmailPlaceholder: "tu@ejemplo.com",
    contactEmailRequired: "Introduce una dirección de correo electrónico válida para que podamos avisarte cuando la siguiente parte esté lista.",
    saveContactEmail: "Guardar correo electrónico",
    contactEmailSaved: "Correo electrónico guardado. Te avisaremos cuando la siguiente parte esté lista.",
    submitError: "Algo salió mal al enviar tu respuesta. Inténtalo de nuevo.",
    replyError: "Tu respuesta se envió, pero Maya no pudo responder. Inténtalo de nuevo en un momento.",
    removeAttachment: "Eliminar adjunto",
    attachmentPreviewRegion: "Vista previa del adjunto",
    reviewAttachmentBeforeSend: "Comprueba que es el archivo correcto antes de enviar.",
    reviewAttachmentsBeforeSend: "Comprueba que son los archivos correctos antes de enviar.",
    reviewVideoBeforeSend: "Comprueba que es el vídeo correcto antes de enviar.",
    reviewAudioBeforeSend: "Comprueba que es el audio correcto antes de enviar.",
    uploadingMedia: "Subiendo…",
    cancelUpload: "Cancelar subida",
    uploadCancelled: "Subida cancelada.",
    attachMedia: "Adjuntar multimedia",
    mediaUploadHint: "Tipos de archivo aceptados: {types}. Máx. {maxSize}.",
    mediaUploadInvalidType: "Ese tipo de archivo no es compatible. Elige uno de los tipos de archivo aceptados.",
    mediaUploadTooLarge: "Ese archivo es demasiado grande. El tamaño máximo de subida es {maxSize}.",
    mediaUploadTooMany: "Puedes adjuntar hasta {max} archivos por mensaje.",
    recordVideo: "Grabar vídeo",
    recorderConsentBody: "Al continuar, consientes que se usen tu cámara y micrófono para grabar tu respuesta en vídeo. Tu grabación se almacenará de forma segura con tus otras respuestas y será revisada por el equipo de investigación.",
    recorderConsentFallback: "¿Prefieres no grabar? Puedes escribir, grabar audio o adjuntar un archivo en su lugar.",
    recorderAccept: "Permitir cámara y micrófono",
    recorderDecline: "Ahora no",
    recorderClose: "Cerrar grabador",
    recorderStart: "Iniciar grabación",
    recorderStop: "Detener grabación",
    recorderRetake: "Volver a grabar",
    recorderUse: "Usar este vídeo",
    recorderRecording: "Grabando",
    recorderPreparingCamera: "Preparando tu cámara…",
    recorderReady: "Pulsa iniciar cuando estés listo para grabar.",
    recorderReview: "Revisa tu grabación y luego úsala o vuelve a grabar.",
    recorderPermissionDenied: "Se bloqueó el acceso a la cámara o al micrófono. Permite el acceso en la configuración del navegador o adjunta un archivo.",
    recorderUnsupported: "La grabación de vídeo no es compatible con este navegador. Prueba a adjuntar un archivo de vídeo.",
    recorderTooShort: "Esa grabación fue demasiado corta. Graba al menos un segundo o inténtalo de nuevo.",
    insertEmoji: "Insertar emoji",
    dictateAnswer: "Dictar respuesta",
    stopDictating: "Dejar de dictar",
    dictateMicError: "Se bloqueó el acceso al micrófono o falló el reconocimiento de voz. Comprueba los permisos del navegador e inténtalo de nuevo.",
    dictateMicDenied: "El acceso al micrófono parece seguir bloqueado para este sitio. Si ya has permitido el micrófono en la configuración del sitio del navegador, actualiza la página e inténtalo de nuevo.",
    dictateNoSpeech: "No se detectó voz. Haz clic en el micrófono e inténtalo de nuevo.",
    dictateConnecting: "Inicializando el micrófono… espera un momento antes de hablar.",
    dictateListening: "Escuchando… habla ahora. Haz clic en el micrófono para detener o en Enviar cuando termines.",
    dictateStartTimeout: "El dictado no se inició a tiempo. Espera un momento e inténtalo de nuevo, o escribe tu respuesta.",
    startingInterview: "Iniciando entrevista…",
    selectLanguage: "Idioma",
    startInterview: "Iniciar entrevista",
    playQuestion: "Reproducir pregunta",
    stopPlayback: "Detener reproducción",
    playbackError: "No se pudo reproducir este mensaje. Lee el texto en su lugar.",
  },
  tr: {
    answerPlaceholder: "Yanıtınızı yazın ve/veya medya yükleyin. Göndermek için Enter, yeni satır için Shift+Enter",
    send: "Gönder",
    thinking: "Düşünüyor…",
    processingMedia: "Medyanız işleniyor…",
    interviewComplete: "Teşekkürler — bu görüşme tamamlandı.",
    groupCompleteAwaitingEmail: "Bu bölümü tamamladığınız için teşekkürler. Sonraki bölüm hazır olduğunda size e-posta göndereceğiz.",
    groupCompleteAwaitingSaveLink: "Bu bölümü tamamladığınız için teşekkürler. Sonraki bölüm hazır olduğunda geri dönebilmek için aşağıdaki bağlantıyı kaydedin.",
    saveLinkReminderTitle: "Bu bağlantıyı kaydedin",
    saveLinkReminderBody: "Bu görüşme birkaç gün boyunca devam eder. E-posta ile gönderilen bağlantıyı kullanın, bu sayfayı yer imlerine ekleyin veya aşağıdaki bağlantıyı kopyalayın — sonraki bölüme dönmek için buna ihtiyacınız olacak.",
    saveLinkEmailDivider: "Veya e-posta ile bildirim alın",
    saveLinkEmailHint: "İsteğe bağlı. Yalnızca bu bağlantıya güvenmek yerine sonraki bölüm hazır olduğunda size e-posta göndereceğiz.",
    copyLink: "Bağlantıyı kopyala",
    linkCopied: "Bağlantı kopyalandı",
    contactEmailLabel: "E-posta adresi",
    contactEmailPlaceholder: "siz@ornek.com",
    contactEmailRequired: "Sonraki bölüm hazır olduğunda sizi bilgilendirebilmemiz için geçerli bir e-posta adresi girin.",
    saveContactEmail: "E-postayı kaydet",
    contactEmailSaved: "E-posta kaydedildi. Sonraki bölüm hazır olduğunda sizi bilgilendireceğiz.",
    submitError: "Yanıtınız gönderilirken bir hata oluştu. Lütfen tekrar deneyin.",
    replyError: "Yanıtınız gönderildi, ancak Maya yanıt veremedi. Lütfen kısa süre sonra tekrar deneyin.",
    removeAttachment: "Eki kaldır",
    attachmentPreviewRegion: "Ek önizlemesi",
    reviewAttachmentBeforeSend: "Göndermeden önce bunun doğru dosya olduğunu kontrol edin.",
    reviewAttachmentsBeforeSend: "Göndermeden önce bunların doğru dosyalar olduğunu kontrol edin.",
    reviewVideoBeforeSend: "Göndermeden önce bunun doğru video olduğunu kontrol edin.",
    reviewAudioBeforeSend: "Göndermeden önce bunun doğru ses dosyası olduğunu kontrol edin.",
    uploadingMedia: "Yükleniyor…",
    cancelUpload: "Yüklemeyi iptal et",
    uploadCancelled: "Yükleme iptal edildi.",
    attachMedia: "Medya ekle",
    mediaUploadHint: "Kabul edilen dosya türleri: {types}. Maks. {maxSize}.",
    mediaUploadInvalidType: "Bu dosya türü desteklenmiyor. Lütfen kabul edilen dosya türlerinden birini seçin.",
    mediaUploadTooLarge: "Bu dosya çok büyük. Maksimum yükleme boyutu {maxSize}.",
    mediaUploadTooMany: "Mesaj başına en fazla {max} dosya ekleyebilirsiniz.",
    recordVideo: "Video kaydet",
    recorderConsentBody: "Devam ederek, video yanıtınızı kaydetmek için kameranızın ve mikrofonunuzun kullanılmasına onay vermiş olursunuz. Kaydınız diğer yanıtlarınızla birlikte güvenli şekilde saklanır ve araştırma ekibi tarafından incelenir.",
    recorderConsentFallback: "Kaydetmek istemiyor musunuz? Bunun yerine yazabilir, ses kaydedebilir veya dosya ekleyebilirsiniz.",
    recorderAccept: "Kamera ve mikrofona izin ver",
    recorderDecline: "Şimdi değil",
    recorderClose: "Kaydediciyi kapat",
    recorderStart: "Kaydı başlat",
    recorderStop: "Kaydı durdur",
    recorderRetake: "Yeniden kaydet",
    recorderUse: "Bu videoyu kullan",
    recorderRecording: "Kayıt",
    recorderPreparingCamera: "Kameranız hazırlanıyor…",
    recorderReady: "Kaydetmeye hazır olduğunuzda başlat'a basın.",
    recorderReview: "Kaydınızı gözden geçirin, ardından kullanın veya yeniden kaydedin.",
    recorderPermissionDenied: "Kamera veya mikrofon erişimi engellendi. Tarayıcı ayarlarından izin verin veya bunun yerine dosya ekleyin.",
    recorderUnsupported: "Bu tarayıcıda video kaydı desteklenmiyor. Bir video dosyası eklemeyi deneyin.",
    recorderTooShort: "Bu kayıt çok kısaydı. En az bir saniye kaydedin veya tekrar deneyin.",
    insertEmoji: "Emoji ekle",
    dictateAnswer: "Yanıtı sesle yaz",
    stopDictating: "Dikteyi durdur",
    dictateMicError: "Mikrofon erişimi engellendi veya konuşma tanıma başarısız oldu. Tarayıcı izinlerini kontrol edip tekrar deneyin.",
    dictateMicDenied: "Bu site için mikrofon erişimi hâlâ engellenmiş görünüyor. Tarayıcı site ayarlarından mikrofonu zaten izin verdiyseniz, lütfen sayfayı yenileyin ve tekrar deneyin.",
    dictateNoSpeech: "Konuşma algılanmadı. Mikrofona tıklayın ve tekrar deneyin.",
    dictateConnecting: "Mikrofon başlatılıyor… konuşmadan önce biraz bekleyin.",
    dictateListening: "Dinleniyor… şimdi konuşun. Durdurmak için mikrofona veya bitince Gönder'e tıklayın.",
    dictateStartTimeout: "Dikte zamanında başlamadı. Biraz bekleyip tekrar deneyin veya yanıtınızı yazın.",
    startingInterview: "Görüşme başlatılıyor…",
    selectLanguage: "Dil",
    startInterview: "Görüşmeyi başlat",
    playQuestion: "Soruyu oynat",
    stopPlayback: "Oynatmayı durdur",
    playbackError: "Bu mesaj oynatılamadı. Lütfen bunun yerine metni okuyun.",
  },
  vi: {
    answerPlaceholder: "Nhập câu trả lời và/hoặc tải lên phương tiện. Nhấn Enter để gửi, Shift+Enter để xuống dòng",
    send: "Gửi",
    thinking: "Đang suy nghĩ…",
    processingMedia: "Đang xử lý phương tiện của bạn…",
    interviewComplete: "Cảm ơn bạn — cuộc phỏng vấn này đã hoàn tất.",
    groupCompleteAwaitingEmail: "Cảm ơn bạn đã hoàn thành phần này. Chúng tôi sẽ gửi email cho bạn khi phần tiếp theo sẵn sàng.",
    groupCompleteAwaitingSaveLink: "Cảm ơn bạn đã hoàn thành phần này. Lưu liên kết bên dưới để bạn có thể quay lại khi phần tiếp theo sẵn sàng.",
    saveLinkReminderTitle: "Lưu liên kết này",
    saveLinkReminderBody: "Cuộc phỏng vấn này diễn ra trong nhiều ngày. Hãy dùng liên kết được gửi qua email, đánh dấu trang này hoặc sao chép liên kết bên dưới — bạn sẽ cần nó để quay lại phần tiếp theo.",
    saveLinkEmailDivider: "Hoặc nhận thông báo qua email",
    saveLinkEmailHint: "Tùy chọn. Chúng tôi sẽ gửi email cho bạn khi phần tiếp theo sẵn sàng, thay vì chỉ dựa vào liên kết này.",
    copyLink: "Sao chép liên kết",
    linkCopied: "Đã sao chép liên kết",
    contactEmailLabel: "Địa chỉ email",
    contactEmailPlaceholder: "ban@vidu.com",
    contactEmailRequired: "Vui lòng nhập địa chỉ email hợp lệ để chúng tôi có thể thông báo khi phần tiếp theo sẵn sàng.",
    saveContactEmail: "Lưu email",
    contactEmailSaved: "Đã lưu email. Chúng tôi sẽ thông báo khi phần tiếp theo sẵn sàng.",
    submitError: "Đã xảy ra lỗi khi gửi câu trả lời. Vui lòng thử lại.",
    replyError: "Câu trả lời của bạn đã được gửi, nhưng Maya không thể phản hồi. Vui lòng thử lại sau giây lát.",
    removeAttachment: "Xóa tệp đính kèm",
    attachmentPreviewRegion: "Xem trước tệp đính kèm",
    reviewAttachmentBeforeSend: "Hãy kiểm tra đây là đúng tệp trước khi gửi.",
    reviewAttachmentsBeforeSend: "Hãy kiểm tra đây là đúng các tệp trước khi gửi.",
    reviewVideoBeforeSend: "Hãy kiểm tra đây là đúng video trước khi gửi.",
    reviewAudioBeforeSend: "Hãy kiểm tra đây là đúng audio trước khi gửi.",
    uploadingMedia: "Đang tải lên…",
    cancelUpload: "Hủy tải lên",
    uploadCancelled: "Đã hủy tải lên.",
    attachMedia: "Đính kèm phương tiện",
    mediaUploadHint: "Loại tệp được chấp nhận: {types}. Tối đa {maxSize}.",
    mediaUploadInvalidType: "Loại tệp này không được hỗ trợ. Vui lòng chọn một trong các loại tệp được chấp nhận.",
    mediaUploadTooLarge: "Tệp này quá lớn. Kích thước tải lên tối đa là {maxSize}.",
    mediaUploadTooMany: "Bạn có thể đính kèm tối đa {max} tệp cho mỗi tin nhắn.",
    recordVideo: "Quay video",
    recorderConsentBody: "Bằng cách tiếp tục, bạn đồng ý cho phép camera và micrô của bạn được sử dụng để ghi lại câu trả lời video. Bản ghi của bạn sẽ được lưu trữ an toàn cùng các câu trả lời khác và được nhóm nghiên cứu xem xét.",
    recorderConsentFallback: "Không muốn quay? Bạn có thể nhập, ghi âm hoặc đính kèm tệp thay thế.",
    recorderAccept: "Cho phép camera và micrô",
    recorderDecline: "Để sau",
    recorderClose: "Đóng trình quay",
    recorderStart: "Bắt đầu quay",
    recorderStop: "Dừng quay",
    recorderRetake: "Quay lại",
    recorderUse: "Dùng video này",
    recorderRecording: "Đang quay",
    recorderPreparingCamera: "Đang chuẩn bị camera…",
    recorderReady: "Nhấn bắt đầu khi bạn sẵn sàng quay.",
    recorderReview: "Xem lại bản quay, sau đó dùng hoặc quay lại.",
    recorderPermissionDenied: "Quyền truy cập camera hoặc micrô bị chặn. Cho phép trong cài đặt trình duyệt hoặc đính kèm tệp thay thế.",
    recorderUnsupported: "Trình duyệt này không hỗ trợ quay video. Hãy thử đính kèm tệp video.",
    recorderTooShort: "Bản quay quá ngắn. Hãy quay ít nhất một giây hoặc thử lại.",
    insertEmoji: "Chèn emoji",
    dictateAnswer: "Nói câu trả lời",
    stopDictating: "Dừng nhập giọng nói",
    dictateMicError: "Quyền truy cập micrô bị chặn hoặc nhận dạng giọng nói thất bại. Hãy kiểm tra quyền trình duyệt và thử lại.",
    dictateMicDenied: "Quyền truy cập micrô có vẻ vẫn bị chặn cho trang này. Nếu bạn đã cho phép micrô trong cài đặt trang web của trình duyệt, hãy làm mới trang và thử lại.",
    dictateNoSpeech: "Không phát hiện giọng nói. Nhấp micrô và thử lại.",
    dictateConnecting: "Đang khởi tạo micrô… hãy đợi một chút trước khi nói.",
    dictateListening: "Đang nghe… hãy nói ngay. Nhấp micrô để dừng hoặc Gửi khi bạn xong.",
    dictateStartTimeout: "Nhập giọng nói không bắt đầu kịp thời. Hãy đợi một chút và thử lại, hoặc nhập câu trả lời.",
    startingInterview: "Đang bắt đầu phỏng vấn…",
    selectLanguage: "Ngôn ngữ",
    startInterview: "Bắt đầu phỏng vấn",
    playQuestion: "Phát câu hỏi",
    stopPlayback: "Dừng phát",
    playbackError: "Không thể phát tin nhắn này. Vui lòng đọc văn bản thay thế.",
  },
  ar: {
    answerPlaceholder: "اكتب إجابتك و/أو ارفع وسائط. اضغط Enter للإرسال، Shift+Enter لسطر جديد",
    send: "إرسال",
    thinking: "جارٍ التفكير…",
    processingMedia: "جارٍ معالجة الوسائط…",
    interviewComplete: "شكرًا لك — اكتملت هذه المقابلة.",
    groupCompleteAwaitingEmail: "شكرًا لإكمال هذا الجزء. سنرسل إليك بريدًا إلكترونيًا عندما يكون الجزء التالي جاهزًا.",
    groupCompleteAwaitingSaveLink: "شكرًا لإكمال هذا الجزء. احفظ الرابط أدناه لتتمكن من العودة عندما يكون الجزء التالي جاهزًا.",
    saveLinkReminderTitle: "احفظ هذا الرابط",
    saveLinkReminderBody: "تستمر هذه المقابلة على عدة أيام. استخدم الرابط الذي أُرسل إليك عبر البريد الإلكتروني، أو احفظ هذه الصفحة، أو انسخ الرابط أدناه — ستحتاجه للعودة للجزء التالي.",
    saveLinkEmailDivider: "أو احصل على إشعار عبر البريد الإلكتروني",
    saveLinkEmailHint: "اختياري. سنرسل إليك بريدًا إلكترونيًا عندما يكون الجزء التالي جاهزًا بدلًا من الاعتماد على هذا الرابط فقط.",
    copyLink: "نسخ الرابط",
    linkCopied: "تم نسخ الرابط",
    contactEmailLabel: "عنوان البريد الإلكتروني",
    contactEmailPlaceholder: "you@example.com",
    contactEmailRequired: "يرجى إدخال عنوان بريد إلكتروني صالح لنُعلمك عندما يكون الجزء التالي جاهزًا.",
    saveContactEmail: "حفظ البريد الإلكتروني",
    contactEmailSaved: "تم حفظ البريد الإلكتروني. سنُعلمك عندما يكون الجزء التالي جاهزًا.",
    submitError: "حدث خطأ أثناء إرسال إجابتك. يرجى المحاولة مرة أخرى.",
    replyError: "تم إرسال إجابتك، لكن مايا لم تتمكن من الرد. يرجى المحاولة مرة أخرى بعد لحظة.",
    removeAttachment: "إزالة المرفق",
    attachmentPreviewRegion: "معاينة المرفق",
    reviewAttachmentBeforeSend: "تحقق من أن هذا هو الملف الصحيح قبل الإرسال.",
    reviewAttachmentsBeforeSend: "تحقق من أن هذه هي الملفات الصحيحة قبل الإرسال.",
    reviewVideoBeforeSend: "تحقق من أن هذا هو الفيديو الصحيح قبل الإرسال.",
    reviewAudioBeforeSend: "تحقق من أن هذا هو الصوت الصحيح قبل الإرسال.",
    uploadingMedia: "جارٍ الرفع…",
    cancelUpload: "إلغاء الرفع",
    uploadCancelled: "تم إلغاء الرفع.",
    attachMedia: "إرفاق وسائط",
    mediaUploadHint: "أنواع الملفات المقبولة للرفع: {types}. الحد الأقصى {maxSize}.",
    mediaUploadInvalidType: "نوع الملف هذا غير مدعوم. يرجى اختيار أحد أنواع الملفات المقبولة.",
    mediaUploadTooLarge: "هذا الملف كبير جدًا. الحد الأقصى لحجم الرفع هو {maxSize}.",
    mediaUploadTooMany: "يمكنك إرفاق ما يصل إلى {max} ملفات لكل رسالة.",
    recordVideo: "تسجيل فيديو",
    recorderConsentBody: "بالمتابعة، فإنك توافق على استخدام الكاميرا والميكروفون لتسجيل إجابتك بالفيديو. سيتم تخزين التسجيل بأمان مع إجاباتك الأخرى ومراجعته من قبل فريق البحث.",
    recorderConsentFallback: "تفضّل عدم التسجيل؟ يمكنك الكتابة أو تسجيل صوت أو إرفاق ملف بدلًا من ذلك.",
    recorderAccept: "السماح بالكاميرا والميكروفون",
    recorderDecline: "ليس الآن",
    recorderClose: "إغلاق المسجل",
    recorderStart: "بدء التسجيل",
    recorderStop: "إيقاف التسجيل",
    recorderRetake: "إعادة التسجيل",
    recorderUse: "استخدام هذا الفيديو",
    recorderRecording: "جارٍ التسجيل",
    recorderPreparingCamera: "جارٍ تجهيز الكاميرا…",
    recorderReady: "اضغط بدء عندما تكون مستعدًا للتسجيل.",
    recorderReview: "راجع تسجيلك، ثم استخدمه أو سجّل مرة أخرى.",
    recorderPermissionDenied: "تم حظر الوصول إلى الكاميرا أو الميكروفون. اسمح بالوصول في إعدادات المتصفح، أو أرفق ملفًا بدلًا من ذلك.",
    recorderUnsupported: "تسجيل الفيديو غير مدعوم في هذا المتصفح. جرّب إرفاق ملف فيديو بدلًا من ذلك.",
    recorderTooShort: "كان التسجيل قصيرًا جدًا. سجّل لمدة ثانية واحدة على الأقل، أو حاول مرة أخرى.",
    insertEmoji: "إدراج رمز تعبيري",
    dictateAnswer: "إملاء الإجابة",
    stopDictating: "إيقاف الإملاء",
    dictateMicError: "تم حظر الوصول إلى الميكروفون أو فشل التعرف على الكلام. تحقق من أذونات المتصفح وحاول مرة أخرى.",
    dictateMicDenied: "يبدو أن الوصول إلى الميكروفون لا يزال محظورًا لهذا الموقع. إذا سمحت بالفعل بالميكروفون في إعدادات الموقع، يرجى تحديث الصفحة ثم المحاولة مرة أخرى.",
    dictateNoSpeech: "لم يتم اكتشاف كلام. انقر على الميكروفون وحاول مرة أخرى.",
    dictateConnecting: "جارٍ تهيئة الميكروفون… انتظر لحظة قبل التحدث.",
    dictateListening: "جارٍ الاستماع… تحدث الآن. انقر على الميكروفون للإيقاف أو أرسل عند الانتهاء.",
    dictateStartTimeout: "لم يبدأ الإملاء في الوقت المناسب. انتظر لحظة وحاول مرة أخرى، أو اكتب إجابتك بدلًا من ذلك.",
    startingInterview: "جارٍ بدء المقابلة…",
    selectLanguage: "اللغة",
    startInterview: "بدء المقابلة",
    playQuestion: "تشغيل السؤال",
    stopPlayback: "إيقاف التشغيل",
    playbackError: "تعذر تشغيل هذه الرسالة. يرجى قراءة النص بدلًا من ذلك.",
  },
};
